// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart___1FApq center___2iqBf","chart-assets":"chart-assets___pT3-R h2___hzLuT line-bottom___2vxnm space-bottom-1___78U5p padding-bottom-1___2nIqf","chart-details":"chart-details___3y_33 center-transform___bd9UT h5___l1yk7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/Chart.css
// module id = 855
// module chunks = 0